import { apiDownload, apiRequest } from '../../services/apiClient';

// Service API keys (doc-33) — admin management of the machine credentials for
// the read-only /api/v1 surface.

export function getServiceKeys() {
  return apiRequest('/admin/service-keys');
}

export function createServiceKey({ name, scopes }) {
  return apiRequest('/admin/service-keys', { method: 'POST', json: { name, scopes } });
}

export function revokeServiceKey(id) {
  return apiRequest(`/admin/service-keys/${id}`, { method: 'DELETE' });
}

// Download a schema's dataset export (CSV or JSON) through the session.
export function downloadSchemaExport(schemaId, { format = 'csv', verification = '' } = {}) {
  const params = new URLSearchParams({ format });
  if (verification) params.set('verification', verification);
  return apiDownload(`/schemas/${schemaId}/export?${params}`, `schema-export.${format}`);
}
